/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService
 */

export const LessonProgressResponseTypename = 'com.hubspot.userprogress.bff.rpc.models.LessonProgressResponse';
export const PlaylistProgressResponseTypename = 'com.hubspot.userprogress.bff.rpc.models.PlaylistProgressResponse';
export const ShortProgressResponseTypename = 'com.hubspot.userprogress.bff.rpc.models.ShortProgressResponse';
export const TrackProgressResponseTypename = 'com.hubspot.userprogress.bff.rpc.models.TrackProgressResponse';
export let ComHubspotUserprogressBffRpcModelsAbstractUserProgressError;
(function (_ComHubspotUserprogressBffRpcModelsAbstractUserProgressError) {})(ComHubspotUserprogressBffRpcModelsAbstractUserProgressError || (ComHubspotUserprogressBffRpcModelsAbstractUserProgressError = {}));
export let ComHubspotUserprogressBffRpcModelsUserprogressAbstractUserProgressReadError;
(function (_ComHubspotUserprogressBffRpcModelsUserprogressAbstractUserProgressReadError) {})(ComHubspotUserprogressBffRpcModelsUserprogressAbstractUserProgressReadError || (ComHubspotUserprogressBffRpcModelsUserprogressAbstractUserProgressReadError = {}));
export const getUserProgressRpc = {
  serviceName: 'com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService',
  rpcName: 'getUserProgress',
  auth: 'app',
  fingerprint: 'EyWYBYoafJiZ7g4bwwu3Wa4AvDvBA3a6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUserLessonProgressRpc = {
  serviceName: 'com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService',
  rpcName: 'getUserLessonProgress',
  auth: 'app',
  fingerprint: '5s9xr8DEglvxay2IAP3bPQxMK10-h47i',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};